<script lang="ts">
  import type { Columns } from "$lib/types/shared";
  import { PortableText, type CustomBlockComponentProps } from "@portabletext/svelte";

  import "@typeform/embed/build/css/widget.css";
  import { contentBlockComponents } from "./utils";

  interface Props {
    portableText: CustomBlockComponentProps<Columns>;
  }

  let { portableText }: Props = $props();
  let { columns } = $derived(portableText.value);
</script>

<div class="columns">
  {#each columns as column (column._key)}
    <div class="column">
      <PortableText
        value={column.content}
        components={contentBlockComponents}
        onMissingComponent={false}
      />
    </div>
  {/each}
</div>

<style>
  .columns {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 3rem;
  }
</style>
